<!-- ✅ Modal para Nueva Tasa MT -->
<ng-template #content let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-6 offset-md-3 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                                Nueva tasa de cambio

                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close"
                                (click)=" offcanvas.dismiss('Cross click'); "></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">

            <div class="row">
                <div class=" col-12 col-md-6 offset-md-3">

                    <div class="d-block d-md-none mt-4 mb-3">
                        <mbsc-date (onSet)="dateSet($event)" [(ngModel)]="date_base" [options]="mobileSettings"
                            placeholder="dd/mm/aaaa">Fecha</mbsc-date>
                    </div>
                    <div class="d-none d-md-block mt-4 mb-3">
                        <mbsc-date (onSet)="dateSet($event)" [(ngModel)]="date_base" [options]="desktopSettings"
                            placeholder="dd/mm/aaaa">Fecha</mbsc-date>
                    </div>

                    <form autocomplete="nope" novalidate [formGroup]="form" class="text-start">

                        <div class="form-group  col-12  mt-1">
                            <div class="form-floating">
                                <select [ngClass]="{'error': form.controls.type.invalid && form.controls.type.dirty}"
                                    class="form-select" id="type" formControlName="type"
                                    aria-label="Floating label select example">
                                    <option value="BS">Bolivares</option>

                                </select>
                                <label for="type">Tipo</label>
                            </div>

                            <div class="form-control-feedback help-block" *ngIf="form.get('type').errors">
                                <div *ngIf="form.get('type').errors['required'] && !form.get('type').pristine">
                                    Campo requerido
                                </div>
                            </div>
                        </div>

                        <div class="form-group  col-12  mt-3">
                            <div class="form-floating ">
                                <input currencyMask (click)="moveCursorToEnd($event)"
                                    [options]="{ precision: 3, prefix:'BS ', thousands: ',', decimal: '.' }"
                                    placeholder="" type="text"
                                    [ngClass]="{'error': form.controls.amount.invalid && form.controls.amount.dirty}"
                                    class="form-control text-capitalize" id="floatingmt" formControlName="amount">
                                <label for="floatingmt" class=" label font-weight-normal"
                                    style="word-wrap: break-word;">
                                    <span>Monto de la tasa </span>

                                </label>
                            </div>

                            <div class="form-control-feedback help-block" *ngIf="form.get('amount').errors">
                                <div *ngIf="form.get('amount').errors['required'] && !form.pristine">
                                    Campo requerido
                                </div>

                                <div *ngIf="form.get('amount').errors['pattern']  && !form.pristine">
                                    Monto inválido
                                </div>

                            </div>


                        </div>

                        <div class="form-group  col-12 mt-4 mb-2">
                            <div class=" float-end">
                                <button data-rbac-permiso="config.tasas.create" *ngIf="_auth.hasPermission('config.tasas.create')" (click)="submit()" [disabled]="!form.valid || submit_disabled"
                                    class="btn btn-block btn-primary ">
                                    <span>Agregar</span>
                                    <span *ngIf="submit_disabled">
                                        <i class="fa  fa-spinner fa-spin ms-2"></i>
                                    </span>
                                </button>
                            </div>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- ✅ Modal para Nueva Tasa Externa (Seguros Mercantil, etc.) -->
<ng-template #contentExternalRate let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-6 offset-md-3 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                                Nueva tasa de cambio - {{ getActiveSourceName() }}
                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close"
                                (click)=" offcanvas.dismiss('Cross click'); "></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">

            <div class="row">
                <div class=" col-12 col-md-6 offset-md-3">

                    <div class="d-block d-md-none mt-4 mb-3">
                        <mbsc-date (onSet)="dateSetExternal($event)" [(ngModel)]="date_base_external"
                            [options]="mobileSettings" placeholder="dd/mm/aaaa">Fecha</mbsc-date>
                    </div>
                    <div class="d-none d-md-block mt-4 mb-3">
                        <mbsc-date (onSet)="dateSetExternal($event)" [(ngModel)]="date_base_external"
                            [options]="desktopSettings" placeholder="dd/mm/aaaa">Fecha</mbsc-date>
                    </div>

                    <form autocomplete="nope" novalidate [formGroup]="formExternal" class="text-start">

                        <div class="form-group  col-12  mt-1">
                            <div class="form-floating">
                                <select
                                    [ngClass]="{'error': formExternal.controls.type.invalid && formExternal.controls.type.dirty}"
                                    class="form-select" id="typeExternal" formControlName="type"
                                    aria-label="Floating label select example">
                                    <option value="BS">Bolivares</option>
                                </select>
                                <label for="typeExternal">Tipo</label>
                            </div>

                            <div class="form-control-feedback help-block" *ngIf="formExternal.get('type').errors">
                                <div
                                    *ngIf="formExternal.get('type').errors['required'] && !formExternal.get('type').pristine">
                                    Campo requerido
                                </div>
                            </div>
                        </div>

                        <div class="form-group  col-12  mt-3">
                            <div class="form-floating ">
                                <input currencyMask (click)="moveCursorToEnd($event)"
                                    [options]="{ precision: 3, prefix:'BS ', thousands: ',', decimal: '.' }"
                                    placeholder="" type="text"
                                    [ngClass]="{'error': formExternal.controls.amount.invalid && formExternal.controls.amount.dirty}"
                                    class="form-control text-capitalize" id="floatingmtExternal"
                                    formControlName="amount">
                                <label for="floatingmtExternal" class=" label font-weight-normal"
                                    style="word-wrap: break-word;">
                                    <span>Monto de la tasa </span>
                                </label>
                            </div>

                            <div class="form-control-feedback help-block" *ngIf="formExternal.get('amount').errors">
                                <div *ngIf="formExternal.get('amount').errors['required'] && !formExternal.pristine">
                                    Campo requerido
                                </div>

                                <div *ngIf="formExternal.get('amount').errors['pattern']  && !formExternal.pristine">
                                    Monto inválido
                                </div>
                            </div>
                        </div>

                        <div class="form-group  col-12 mt-4 mb-2">
                            <div class=" float-end">
                                <button data-rbac-permiso="config.tasas.create" *ngIf="_auth.hasPermission('config.tasas.create')" (click)="submitExternal()"
                                    [disabled]="!formExternal.valid || submit_disabled_external"
                                    class="btn btn-block btn-primary ">
                                    <span>Agregar</span>
                                    <span *ngIf="submit_disabled_external">
                                        <i class="fa  fa-spinner fa-spin ms-2"></i>
                                    </span>
                                </button>
                            </div>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </div>
</ng-template>

<div class="mt-md-3 container-fluid">

    <div class="row mt-2 justify-content-center">
        <div class="col-12 col-xl-11 col-xxl-10 px-3 px-md-4">
            <div class="row rmt-2">
                <div class="col-12">


                    <div class="row rmt-2">
                        <div class="col-12">
                            <h5 class="mb-1 text-secondary mb-4 text-center">
                                <i class="fas fa-dollar-sign"></i> Tasas de Cambio
                            </h5>
                        </div>
                    </div>


                    <div class="row justify-content-center">
                        <div class="col-12 col-xl-11 col-xxl-10 mt-3 mb-5">
                            <input style="
                            padding: 16px 9px;
                            background: white;
                        " id="demo-external" (onSet)="birthdaySet()" [(ngModel)]="range" mbsc-range class="form-control"
                                [mbsc-options]="dateSetting3" #externalRange="mobiscroll" />
                        </div>
                    </div>


                    <ng-container *ngIf="loading">
                        <div class="w-100 text-center mt-2">
                            <img src="./assets/public/images/loading.gif" alt=" ">
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!loading">

                        <!-- ✅ Layout reorganizado con límite de ancho -->
                        <div class="row justify-content-center">
                            <div class="col-12 col-xl-11 col-xxl-10">
                                <div class="row">
                                    <!-- Columna principal: Tabs y contenido -->
                                    <div class="col-12">
                                        <!-- Pestañas -->
                                        <ul class="nav nav-tabs mb-4" role="tablist">
                                            <li class="nav-item" role="presentation" *ngFor="let source of rateSources">
                                                <button class="nav-link" [class.active]="activeTab === source.code"
                                                    (click)="changeTab(source.code)" type="button">
                                                    {{ source.name }}
                                                </button>
                                            </li>
                                        </ul>

                                        <!-- Contenido de cada pestaña -->
                                        <div class="row">
                                            <!-- Columna izquierda: Lista de tasas -->
                                            <div class="col-12 col-lg-6">
                                        <div class="d-flex justify-content-between align-items-center mb-3">
                                            <span class="fw-bold h5 mb-0">Bolivares</span>
                                            <div>
                                                <!-- ✅ Botón para cargar tasa externa (visible en pestañas que no sean MT) -->
                                                <button data-rbac-permiso="config.tasas.create" *ngIf="activeTab !== 'MT' && _auth.hasPermission('config.tasas.create')" class="btn btn-success btn-sm"
                                                    (click)="pocisionBottom(contentExternalRate)">
                                                    <i class="fas fa-plus me-1"></i>Nueva
                                                </button>
                                                <!-- Botón de nueva tasa manual (solo para MT) -->
                                                <button data-rbac-permiso="config.tasas.create" *ngIf="activeTab === 'MT' && _auth.hasPermission('config.tasas.create')" class="btn btn-primary btn-sm"
                                                    (click)="pocisionBottom(content)">
                                                    <i class="fas fa-plus me-1"></i>Nueva
                                                </button>
                                            </div>
                                        </div>

                                        <div *ngIf="rates?.length < 1 && !loading" class="alert alert-info">
                                            <i class="fas fa-info-circle me-2"></i>No se encontraron tasas a esta fecha
                                        </div>

                                        <div *ngIf="rates?.length > 0 && !loading" class="bg-body rounded shadow-sm">
                                            <div class="d-flex text-dark border-bottom" *ngFor="let item of rates; let last = last"
                                                [class.border-bottom-0]="last">
                                                <div class="p-3 w-100">
                                                    <div class="d-flex justify-content-between">
                                                        <div>
                                                            <div class="text-secondary text-capitalize fw-bold"
                                                                *ngIf="item?.chanel == 'CREDIT_API-historyRateExchangeApi'">
                                                                <i class="fas fa-robot me-1"></i>SYSTEM-MT
                                                            </div>
                                                            <div class="text-secondary text-capitalize fw-bold"
                                                                *ngIf="item?.chanel == 'CREDIT_API-updateBCVRate'">
                                                                <i class="fas fa-university me-1"></i>SYSTEM-BCV
                                                            </div>
                                                            <div class="text-secondary text-capitalize fw-bold"
                                                                *ngIf="item?.chanel == 'SEGUROS_MERCANTIL'">
                                                                <i class="fas fa-shield-alt me-1"></i>MERCANTIL SEGUROS
                                                            </div>
                                                            <div class="text-secondary text-capitalize fw-bold"
                                                                *ngIf="item?.chanel == 'SEGUROS_CARACAS'">
                                                                <i class="fas fa-shield-alt me-1"></i>SEGUROS CARACAS
                                                            </div>
                                                            <div class="text-secondary text-capitalize small mt-1">
                                                                {{item?.ejecutive?.name}} {{item?.ejecutive?.lastName}}
                                                            </div>
                                                            <div class="text-muted small">
                                                                <i class="far fa-clock me-1"></i>{{item?.date_consult | date: 'dd/MM/yyyy h:mm:ss a'}}
                                                            </div>
                                                        </div>
                                                        <div class="text-end">
                                                            <div class="fw-bold h5 mb-1">{{ toFixedApp(item?.amount)}}</div>
                                                            <div class="text-muted small">
                                                                <i class="far fa-calendar me-1"></i>{{item?.date | date: 'dd/MM/yyyy'}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Fin columna izquierda -->

                                    <!-- Columna derecha: Panel de configuración por pestaña -->
                                    <div class="col-12 col-lg-6 mt-4 mt-lg-0">
                                        <div class="p-4 bg-body rounded shadow-sm h-100">
                                            <div class="mb-4">
                                                <h6 class="fw-bold mb-0">
                                                    <i class="fas fa-cog me-2 text-primary"></i>Configuración
                                                </h6>
                                                <small class="text-muted">{{ getActiveSourceName() }}</small>
                                                <hr class="mt-2 mb-3">
                                            </div>

                                            <!-- Configuración para MT (Principal) -->
                                            <div *ngIf="activeTab === 'MT'">
                                                <div class="mb-3">
                                                    <div class="fw-bold mb-2">
                                                        <i class="fas fa-eye me-2"></i>Mostrar tasa a clientes
                                                    </div>
                                                    <div class="text-secondary small mb-3">
                                                        Controla si los clientes pueden ver la tasa de cambio en la aplicación móvil
                                                    </div>
                                                    <div class="d-flex justify-content-between align-items-center p-3 bg-light rounded">
                                                        <span class="text-muted">Estado:</span>
                                                        <div class="d-flex align-items-center">
                                                            <div class="form-check form-switch">
                                                                <input *ngIf="showClientRate !== null" class="form-check-input"
                                                                    type="checkbox" role="switch" id="showClientRateSwitch"
                                                                    [checked]="showClientRate" (change)="onToggleChange($event)"
                                                                    [disabled]="toggleLoading || !_auth.hasPermission('config.tasas.config')"
                                                                    style="width: 3rem; height: 1.5rem; cursor: pointer;">
                                                                <span *ngIf="toggleLoading" class="ms-2">
                                                                    <i class="fa fa-spinner fa-spin"></i>
                                                                </span>
                                                                <span *ngIf="showClientRate === null" class="ms-2">
                                                                    <i class="fa fa-spinner fa-spin"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mt-2">
                                                        <span class="badge px-3 py-2" [class.bg-success]="showClientRate"
                                                            [class.bg-secondary]="!showClientRate">
                                                            <i class="fas" [class.fa-check-circle]="showClientRate"
                                                                [class.fa-times-circle]="!showClientRate"></i>
                                                            {{ showClientRate ? 'Visible' : 'Oculto' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Configuración para Seguros Mercantil -->
                                            <div *ngIf="activeTab === 'SEGUROS_MERCANTIL'">
                                                <div class="mb-3">
                                                    <div class="fw-bold mb-2">
                                                        <i class="fas fa-eye me-2"></i>Mostrar tasa a clientes
                                                    </div>
                                                    <div class="text-secondary small mb-3">
                                                        Controla si los clientes pueden ver la tasa de Mercantil Seguros en la aplicación móvil
                                                    </div>
                                                    <div class="d-flex justify-content-between align-items-center p-3 bg-light rounded">
                                                        <span class="text-muted">Estado:</span>
                                                        <div class="d-flex align-items-center">
                                                            <div class="form-check form-switch">
                                                                <input *ngIf="showMsRate !== null" class="form-check-input"
                                                                    type="checkbox" role="switch" id="showMsRateSwitch"
                                                                    [checked]="showMsRate" (change)="onToggleChange($event)"
                                                                    [disabled]="toggleLoading || !_auth.hasPermission('config.tasas.config')"
                                                                    style="width: 3rem; height: 1.5rem; cursor: pointer;">
                                                                <span *ngIf="toggleLoading" class="ms-2">
                                                                    <i class="fa fa-spinner fa-spin"></i>
                                                                </span>
                                                                <span *ngIf="showMsRate === null" class="ms-2">
                                                                    <i class="fa fa-spinner fa-spin"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mt-2">
                                                        <span class="badge px-3 py-2" [class.bg-success]="showMsRate"
                                                            [class.bg-secondary]="!showMsRate">
                                                            <i class="fas" [class.fa-check-circle]="showMsRate"
                                                                [class.fa-times-circle]="!showMsRate"></i>
                                                            {{ showMsRate ? 'Visible' : 'Oculto' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Configuración para Seguros Caracas -->
                                            <div *ngIf="activeTab === 'SEGUROS_CARACAS'">
                                                <div class="mb-3">
                                                    <div class="fw-bold mb-2">
                                                        <i class="fas fa-eye me-2"></i>Mostrar tasa a clientes
                                                    </div>
                                                    <div class="text-secondary small mb-3">
                                                        Controla si los clientes pueden ver la tasa de Seguros Caracas en la aplicación móvil
                                                    </div>
                                                    <div class="d-flex justify-content-between align-items-center p-3 bg-light rounded">
                                                        <span class="text-muted">Estado:</span>
                                                        <div class="d-flex align-items-center">
                                                            <div class="form-check form-switch">
                                                                <input *ngIf="showScRate !== null" class="form-check-input"
                                                                    type="checkbox" role="switch" id="showScRateSwitch"
                                                                    [checked]="showScRate" (change)="onToggleChange($event)"
                                                                    [disabled]="toggleLoading"
                                                                    style="width: 3rem; height: 1.5rem; cursor: pointer;">
                                                                <span *ngIf="toggleLoading" class="ms-2">
                                                                    <i class="fa fa-spinner fa-spin"></i>
                                                                </span>
                                                                <span *ngIf="showScRate === null" class="ms-2">
                                                                    <i class="fa fa-spinner fa-spin"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mt-2">
                                                        <span class="badge px-3 py-2" [class.bg-success]="showScRate"
                                                            [class.bg-secondary]="!showScRate">
                                                            <i class="fas" [class.fa-check-circle]="showScRate"
                                                                [class.fa-times-circle]="!showScRate"></i>
                                                            {{ showScRate ? 'Visible' : 'Oculto' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                            <!-- Fin columna derecha -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Fin row principal -->


                    </ng-container>


                    <!-- <pre>{{ rates | json }}</pre> -->
                </div>
            </div>
        </div>
    </div>
</div>